import { render } from "./registration-account-created.vue?vue&type=template&id=4f934122&scoped=true"
import script from "./registration-account-created.vue?vue&type=script&lang=js"
export * from "./registration-account-created.vue?vue&type=script&lang=js"

import "./registration-account-created.vue?vue&type=style&index=0&id=4f934122&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f934122"]])

export default __exports__